import { render, staticRenderFns } from "./AnswerInset.vue?vue&type=template&id=5494f6ba"
import script from "./AnswerInset.vue?vue&type=script&lang=js"
export * from "./AnswerInset.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports